import { memo, type ReactNode } from "react";

import "./TooltipContainer.css";

interface Props {
  children?: ReactNode;
  maxHeight?: number;
  onMouseOver?: () => void;
  onFocus?: () => void;
}

const TooltipContainer = ({
  children,
  maxHeight,
  onMouseOver,
  onFocus,
}: Props) => (
  <span
    className="tooltip-container"
    style={
      maxHeight
        ? { overflow: "hidden", maxHeight: `${maxHeight}rem` }
        : undefined
    }
    onMouseOver={onMouseOver}
    onFocus={onFocus}
  >
    {children}
  </span>
);

TooltipContainer.defaultProps = {
  children: undefined,
  maxHeight: 0,
  onMouseOver: undefined,
  onFocus: undefined,
};

export default memo(TooltipContainer);
